module.exports = __webpack_public_path__ + "static/img/您的睡眠呼吸专家.4420c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/您的睡眠呼吸专家.png
// module id = naWL
// module chunks = 1